<template>
  <div class="sub-page">
    <MatchRank/>
  </div>
</template>

<script>
import AntdvEmpty from '@comm/components/public/AntdvEmpty.vue'
import MatchRank from '@comm/components/MatchRank.vue'
import VolleyballSelect from './VolleyballSelect.vue'
export default {
  name: 'VolleyballRank',
  props: {
    rankList: {
      type: Array,
      default: () => [],
    },
    componentName: {
      type: String,
      default: 'VolleyballRank',
    },
  },
  data () {
    return {
      teamList: [{ name: 'A组' }, { name: 'B组' }, { name: 'C组' }, { name: 'D组' }],
      teamIndex: 0,
      tabIndex: 0,
    }
  },
  components: { AntdvEmpty, VolleyballSelect,MatchRank },
  mounted () {
  },
  methods: {
    handleTab (item, index) {
      this.tabIndex = index
    },
    handleTeam (item, index) {
      this.teamIndex = index
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  margin-bottom: 30px;
  .team-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 30px;
    .team-item {
      width: 90px;
      line-height: 40px;
      text-align: center;
      height: 40px;
      border: 1px solid #d3d3d3;
      margin-right: 10px;
      cursor: pointer;
    }
    .active {
      color: #ffffff;
      background-color: #aa1f23;
      border: 1px solid #aa1f23;
    }
  }
  .row {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    height: 70px;
    .col-1 {
      width: 5%;
      text-align: center;
    }
    .col-2 {
      width: 10%;
      text-align: center;
    }
    .col-3 {
      width: 5%;
      text-align: center;
    }
    .col-4 {
      width: 15%;
      text-align: center;
      padding: 0 10px;
      box-sizing: border-box;
      .col-4-1 {
        width: 100%;
        border-bottom: 1px solid #acd0fd;
        margin-bottom: 2px;
        padding-bottom: 2px;
      }
      .col-4-2 {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        div {
          width: 100%;
        }
      }
    }
    .col-5 {
      width: 10%;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      .col-5-1 {
        width: 100%;
        border-bottom: 1px solid #acd0fd;
        margin-bottom: 2px;
        padding-bottom: 2px;
      }
      .col-5-2 {
        display: flex;
        font-size: 14px;
        justify-content: space-between;
        div {
          width: 100%;
        }
      }
    }
    .col-6 {
      width: 10%;
      text-align: center;
      padding: 0 10px;
      box-sizing: border-box;
      .col-6-1 {
        width: 100%;
        border-bottom: 1px solid #acd0fd;
        margin-bottom: 2px;
        padding-bottom: 2px;
      }
      .col-6-2 {
        display: flex;
        font-size: 14px;
        justify-content: space-between;
        div {
          width: 100%;
        }
      }
    }
    .col-7 {
      width: 30%;
      text-align: center;
      padding: 0 10px;
      box-sizing: border-box;
      .col-7-1 {
        width: 100%;
        border-bottom: 1px solid #acd0fd;
        margin-bottom: 2px;
        padding-bottom: 2px;
      }
      .col-7-2 {
        width: 100%;
        display: flex;
        font-size: 14px;
        justify-content: space-between;
        div {
          width: 100%;
        }
      }
    }
    .col-8 {
      width: 5%;
      text-align: center;
      div {
        width: 100%;
      }
    }
    .col-9 {
      width: 5%;
      text-align: center;
      div {
        width: 100%;
      }
    }
    .col-10 {
      width: 5%;
      text-align: center;
      div {
        width: 100%;
      }
    }
  }
  .row-title {
    font-size: 18px;
    font-weight: bold;
    border-bottom: 4px solid #acd0fd;
    background-color: #f7fafc;
  }
  .row-active {
    background-color: #f7fafc;
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballRank.vue